module.exports = __webpack_public_path__ + "img/Loulou-Max-Quality.9cb02e70.jpg";